import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75" {...props}><path data-name="Caminho 1" d="M51.949 46.075h-3.093l-1.1-1.057a25.492 25.492 0 10-2.741 2.741l1.057 1.1v3.094L65.655 71.49l5.835-5.835zm-23.5 0a17.622 17.622 0 1117.626-17.621 17.6 17.6 0 01-17.621 17.621z" /><path data-name="Caminho 2" d="M0 0h75v75H0z" fill="none" /></svg>);